import { UserActions, USER_ACTION_TYPE } from './user-type';
import { RootState } from '../../../../redux/root-reducer';

export enum USER_STATE_KEY {
  LIST = 'LIST',
  BRANCH_FILTER_LIST = 'BRANCH_FILTER_LIST',
  BRANCH_FILTER_DEFAULT_ID = 'BRANCH_FILTER_DEFAULT_ID',
}

export type UserState = {
  [USER_STATE_KEY.LIST]?: [],
  [USER_STATE_KEY.BRANCH_FILTER_LIST]?: [],
  [USER_STATE_KEY.BRANCH_FILTER_DEFAULT_ID]?: string,
};

const initialState: UserState = {
  [USER_STATE_KEY.LIST]: [],
  [USER_STATE_KEY.BRANCH_FILTER_LIST]: undefined,
  [USER_STATE_KEY.BRANCH_FILTER_DEFAULT_ID]: undefined
};

export const userReducers = (state = initialState, action: UserActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case USER_ACTION_TYPE.SET_USER_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const userStateSelector = (key: USER_STATE_KEY) => (state: RootState) => state.user[key];
